import { FC } from 'react';
import { ConfirmDialog, customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { useRotateAccessToken } from '../../hooks';
import { AccessToken, SafeAccessToken } from '@agilelab/plugin-wb-auth-backend';
import { useApi } from '@backstage/core-plugin-api';

type RotateAccessTokenDialogProps = {
  token: SafeAccessToken | null;
  onClose: () => void;
  onRotated?: (newToken: AccessToken) => void;
};

export const RotateAccessTokenDialog: FC<RotateAccessTokenDialogProps> = ({
  token,
  onClose,
  onRotated,
}) => {
  const alertApi = useApi(customAlertApiRef);
  const { isLoading: rotating, mutate: rotateFn } = useRotateAccessToken();

  return (
    <ConfirmDialog
      inProgress={rotating}
      open={Boolean(token)}
      onClick={e => e.stopPropagation()}
      onClose={onClose}
      title="Are you sure you want to regenerate the access token?"
      description="The current token will be invalidated and a new one with the same expiration date will be generated. This action can’t be undone."
      confirmButtonText="Regenerate"
      onConfirm={() => {
        if (!token) return;
        rotateFn(token, {
          onSuccess: newToken => {
            onRotated?.(newToken);
            onClose();
            alertApi.post({
              severity: 'info',
              message: 'Access token regenerated successfully',
            });
          },
          onError: () => {
            onClose();
          },
        });
      }}
    />
  );
};
